import React, { useEffect, useState } from 'react';
import instructorService from '../../../services/instructorService';
import coursesService from '../../../services/coursesService';
import { useParams, useNavigate } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaStar } from 'react-icons/fa';
import { FiVideo, FiUser, FiPlay } from 'react-icons/fi';
import CourseCard from '../../../components/Cours/CourseCard';

const InstructorProfile = () => {
   const { id } = useParams();
   const [instructor, setInstructor] = useState(null);
   const [courses, setCourses] = useState([]);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);
   const [activeTab, setActiveTab] = useState('overview');
   const [showFullDescription, setShowFullDescription] = useState(false);
   const navigate = useNavigate();

   const handleCourseClick = (courseId) => {
      navigate(`/courses-single/${courseId}`);
   };

   const toggleDescription = () => {
      setShowFullDescription(!showFullDescription);
   };

   const fetchInstructorDetails = async (instructorId) => {
      try {
         setLoading(true);
         const data = await instructorService.getInstructorById(instructorId);

         console.log("Données de l'instructeur récupérées :", data);

         if (data) {
            setInstructor(data);
         } else {
            setError('Erreur lors du chargement du cours');
         }
      } catch (err) {
         setError('Erreur de connexion au serveur');
         console.error('Erreur:', err);
      }
   };

   const fetchInstructorCourses = async (instructorId) => {
      try {
         const data = await coursesService.getCoursesByAuthorgetCoursesByInstructorId(instructorId);
         if (data) {
            setCourses(data);
         } else {
            console.error('Erreur lors du chargement des cours de l\'instructeur');
         }
      } catch (err) {
         console.error('Erreur de connexion au serveur:', err);
      }
   }

   useEffect(() => {
      if (id) {
         fetchInstructorDetails(id);
         fetchInstructorCourses(id);
      }
   }, [id]);

   useEffect(() => {
      if (instructor) {
         setLoading(false);
      }
   }, [instructor]);

   if (loading) {
      return <div className="flex justify-center items-center min-h-64 text-gray-600">Chargement...</div>;
   }

   if (error) {
      return <div className="flex justify-center items-center min-h-64 text-red-500">{error}</div>;
   }

   if (!instructor) {
      return <div className="flex justify-center items-center min-h-64 text-gray-600">Instructeur non trouvé</div>;
   }


   return (
      <div className="dark:bg-dark-1">
         {/* Header Section */}
         <section className="relative bg-purple-1 p-6 md:p-12 lg:p-16 rounded-xl">
            <div className="px-0 md:px-4">
               <div className="flex justify-center">
                  <div className="w-full flex flex-col  items-center md:items-start gap-8">
                     <div className="w-32 h-32 md:w-40 md:h-40 overflow-hidden shadow-lg flex-shrink-0">
                        <img
                           src={instructor.image || "/general/avatar-1.png"}
                           alt="Ali Tufan"
                           className="w-full h-full object-cover"
                        />
                     </div>

                     <div className="mt-0 md:mt-6 text-center md:text-left">
                        <h1 className="text-2xl md:text-3xl font-bold text-white">{instructor.name}</h1>
                        <div className="text-white opacity-90 mt-1">{instructor.role}</div>

                        <div className="flex flex-wrap justify-center md:justify-start gap-3 md:gap-4 mt-4 md:mt-6">
                           <div className="flex items-center text-white">
                              <FaStar className="mr-2" />
                              <span className="text-sm">{instructor.rating} rating</span>
                           </div>

                           {/* <div className="flex items-center text-white">
                              <FiVideo className="mr-2" />
                              <span className="text-sm">{instructor.students} Reviews</span>
                           </div> */}

                           <div className="flex items-center text-white">
                              <FiUser className="mr-2" />
                              <span className="text-sm">{instructor.students} Students</span>
                           </div>

                           <div className="flex items-center text-white">
                              <FiPlay className="mr-2" />
                              <span className="text-sm">{instructor.courses} Course</span>
                           </div>
                        </div>

                        <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start mt-6 md:mt-8 gap-4">
                           <button className="px-6 md:px-[55px] py-3 md:py-[12px] bg-green-400 text-dark-1 border 
                           border-green-400 font-medium rounded-md transition-colors hover:text-green-400
                           hover:bg-purple-1 h-[50px] md:h-[60px] w-full sm:w-auto">
                              Send Message
                           </button>

                           <div className="flex gap-4 text-white">
                              <a href="#" className="hover:text-green-300 transition-colors">
                                 <FaFacebook size={20} />
                              </a>
                              <a href="#" className="hover:text-green-300 transition-colors">
                                 <FaTwitter size={20} />
                              </a>
                              <a href="#" className="hover:text-green-300 transition-colors">
                                 <FaInstagram size={20} />
                              </a>
                              <a href="#" className="hover:text-green-300 transition-colors">
                                 <FaLinkedin size={20} />
                              </a>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>

         {/* Content Section */}
         <div className="py-8 md:py-12 w-full">
            <div className="pl-0 md:pl-8 lg:pl-16 xl:pl-32 w-full">
               <div className="flex w-full">
                  <div className="w-full lg:w-10/12 xl:w-8/12">
                     {/* Tabs */}
                     <div className="border-b border-gray-200 dark:border-gray-700 w-full">
                        <div className="flex space-x-4 md:space-x-8 w-full">
                           <button
                              className={`pb-4 px-1 font-medium ${activeTab === 'overview'
                                 ? 'text-purple-1 border-b-2 border-purple-1'
                                 : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`}
                              onClick={() => setActiveTab('overview')}
                           >
                              Overview
                           </button>
                           <button
                              className={`pb-4 px-1 font-medium ${activeTab === 'courses'
                                 ? 'text-purple-1 border-b-2 border-purple-1'
                                 : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`}
                              onClick={() => setActiveTab('courses')}
                           >
                              Courses
                           </button>
                        </div>
                     </div>

                     {/* Tab Content */}
                     <div className="pt-8 md:pt-12">
                        {activeTab === 'overview' && (
                           <div>
                              <div className="relative mt-4 md:mt-6">
                                 <div
                                    className={`text-gray-600 dark:text-gray-300 transition-all duration-500 ease-in-out
                  overflow-hidden ${showFullDescription ? 'max-h-[1000px]' : 'max-h-[180px]'}`}
                                 >
                                    <p>
                                       Phasellus enim magna, varius et commodo ut, ultricies vitae velit. Ut nulla tellus, eleifend euismod pellentesque vel, sagittis vel justo. In libero urna, venenatis sit amet ornare non, suscipit nec risus. Sed consequat justo non mauris pretium at tempor justo sodales. Quisque tincidunt laoreet malesuada. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur.
                                    </p>
                                    <p className="mt-4">
                                       This course is aimed at people interested in UI/UX Design. We'll start from the very beginning and work all the way through, step by step. If you already have some UI/UX Design experience but want to get up to speed using Adobe XD then this course is perfect for you too!
                                    </p>
                                    <p className="mt-4">
                                       First, we will go over the differences between UX and UI Design. We will look at what our brief for this real-world project is, then we will learn about low-fidelity wireframes and how to make use of existing UI design kits.
                                    </p>
                                 </div>

                                 {/* Overlay de dégradé */}
                                 {!showFullDescription && (
                                    <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent
               dark:from-dark-1 dark:to-transparent pointer-events-none"></div>
                                 )}
                              </div>

                              <button
                                 onClick={toggleDescription}
                                 className="text-purple-1 font-medium underline mt-2 flex items-center
                                          dark:hover:text-purple-300 transition-colors"
                              >
                                 {showFullDescription ? (
                                    <>
                                       <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                       </svg>
                                       Show Less
                                    </>
                                 ) : (
                                    <>
                                       <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                       </svg>
                                       Show More
                                    </>
                                 )}
                              </button>
                           </div>
                        )}

                        {activeTab === 'courses' && (
                           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                              {courses.map((course, index) => (
                                 <div
                                    key={course.id}
                                    className="flex-none"
                                 >
                                    <CourseCard course={course} animationDelay={index + 1} onClick={() => handleCourseClick(course.id)} />
                                 </div>
                              ))}
                           </div>
                        )}
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default InstructorProfile;